document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
    let subMenus = document.querySelectorAll(
      '.mobileNav__list .menu-item-has-children'
    );
    subMenus.forEach((subMenu) => {
      let link = subMenu.querySelector('a');
      let span = subMenu.querySelector('span');
      let ul = subMenu.querySelector('ul');
      link.addEventListener('click', (e) => {
        if (subMenu.querySelector('span')) {
          e.preventDefault();
          ul.classList.toggle('sub-menu--open');
          span.classList.toggle('open');
        }
      });
    });
  }
  const hamburgers = document.querySelectorAll('.header__hamburger');
  const mobileNav = document.querySelector('.mobileNav');
  hamburgers.forEach(hamburger => {
    hamburger.addEventListener('click', () => {
      hamburgers.forEach(h => {
        h.classList.toggle('hamburger--opened');
        h.setAttribute(
          'aria-expanded',
          h.classList.contains('hamburger--opened')
        );
      })
      mobileNav.classList.toggle('open');
      if (document.querySelector('.mobileNav__list .menu-item-has-children') && !hamburger.classList.contains('hamburger--opened')) {
        let subMenus = document.querySelectorAll(
          '.mobileNav__list .menu-item-has-children'
        );

        subMenus.forEach((subMenu) => {
          let span = subMenu.querySelector('span');
          let ul = subMenu.querySelector('ul');
          ul.classList.remove('sub-menu--open');
          span.classList.remove('open');

        });
      }
    });

  });
  const mobileNavItems = document.querySelectorAll('.mobileNav a')
  if (mobileNavItems)
    mobileNavItems.forEach(mobileNavItem => {
      mobileNavItem.addEventListener('click', (e) => {
        if (e.target.classList.contains('menu-item-open-submenu') || e.target.parentNode.classList.contains('menu-item-open-submenu'))
          return
        hamburgers.forEach(h => {
          h.classList.toggle('hamburger--opened');
          h.setAttribute(
            'aria-expanded',
            h.classList.contains('hamburger--opened')
          );
        })
        mobileNav.classList.toggle('open');
      })
    });

  const header = document.querySelector('.header');

  const btn = document.querySelector('.scrollTop');

  var lastPosition = document.documentElement.scrollTop;
  var direction = 'down';
  window.addEventListener('scroll', () => {

    if (lastPosition < document.documentElement.scrollTop)
      direction = 'down'
    else
      direction = 'up';


    if (direction == 'up' || mobileNav.classList.contains('open')) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--hidden');
      btn.classList.remove('scrollTop--hidden')
    } 
    else {
      // header.classList.remove('header--scrolled');
      header.classList.add('header--hidden');
      btn.classList.add('scrollTop--hidden')
    }
    lastPosition = document.documentElement.scrollTop;
    if (!(document.body.scrollTop > 120 || document.documentElement.scrollTop > 120)) {
      header.classList.remove('header--scrolled');
      header.classList.remove('header--hidden');
      setTimeout(()=>{
        // header.style.position = "absolute"
      },300)
    } else {
      // header.classList.add('header--scrolled');
      // header.classList.add('header--hidden');
      btn.classList.add('scrollTop--hidden')
      header.style.position = "fixed"
    }
  });


  if (btn) btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
})

document.addEventListener('DOMContentLoaded', () => {
  const logosSlider = document.querySelector('.logos__slider');
  if (logosSlider && typeof Swiper !== 'undefined') {
    new Swiper(logosSlider, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 40,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        800: { slidesPerView: 3, spaceBetween: 60 },
        1240: { slidesPerView: 4, spaceBetween: 80 },
      },
    });
  }
});
